import { defineStore } from 'pinia';
import { useAlertStore } from './alert';
import { httpAPI } from '@/services/ajax';
import { shouldShowError } from '@/utils/errorHelper';
import app from '@/main.js';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        fetching: false, // are we currently fetching the record?

        hasUnread: false,
        hasUnreadMessage: false,
        urgentModules: [],

        isPanelVisible: false,
        activeTab: 'LIST',
        currentAlert: null,
    }),
    actions: {
        openPanel() {
            this.isPanelVisible = true;
        },

        closePanel() {
            this.isPanelVisible = false;
            this.activeTab = 'LIST';
            this.currentAlert = null;
        },

        openList() {
            this.isPanelVisible = true;
            this.activeTab = 'LIST';
        },

        openView(alert) {
            this.isPanelVisible = true;
            this.activeTab = 'VIEW';
            this.currentAlert = alert;
        },

        _fetchData() {
            /** Fetch notification from API and perform the given callback once completed */

            this.fetching = true;

            const vm = this;
            const url = app.config.globalProperties.$env.apiRoot + 'notification/check';

            httpAPI(url, null, 'GET', app.config.globalProperties.$router)
                .then((response) => {
                    if (response.success) {
                        Object.freeze(response.data);
                        vm.hasUnread = response.data.has_unread;
                        vm.hasUnreadMessage = response.data.has_unread_message;
                        vm.urgentModules = response.data.urgent_modules;
                    } else if (shouldShowError(response)) {
                        const alertStore = useAlertStore();
                        alertStore.pushError(
                            'Failed to fetch data for notification store: ' + response.message
                        );
                    }

                    this.fetching = false;
                })
                .catch(() => {
                    this.fetching = false;
                });
        },

        sync() {
            /** Fetch the user from the API (if necessary), then perform the callback function once completed */
            if (!this.fetching) this._fetchData();
        },
    },
});
